/* eslint-disable react/prop-types */
import React from 'react';
import { withProductSelector } from 'Protons/withProductSelector';
import { ProductSelector } from 'Components/molecules/ProductSelector';

export const getProductSelector = ({
  mainTitle = '',
  title = 'Find a car review',
  showCta = false,
  ctaLabel = '',
  loadStyles = true,
  extraClassNames = {},
}) => {
  const WrappedProductSelector = withProductSelector(ProductSelector);
  return (
    <WrappedProductSelector
      mainTitle={mainTitle}
      title={title}
      showCta={showCta}
      ctaLabel={ctaLabel}
      loadStyles={loadStyles}
      extraClassNames={extraClassNames}
    />
  );
};
